import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    setIsTransitioning(true);
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className={`page-transition-wrapper ${isTransitioning ? 'transitioning' : ''}`}>
      {children}
      {isTransitioning && (
        <div className="page-transition-overlay">
          <div className="transition-loader">
            <div className="loader-spinner"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageTransition;